import { DateRange } from '@mui/lab'
import { Dayjs } from 'dayjs'
import httpRequest from 'httpRequest'
import {
    CompletableContract,
    SaleLookupContract,
    SaleRefundDetailLookupContract,
} from 'models'
import {
    GiftCardSaleDetailContract,
    PaymentResultContract,
    SaleType,
    SummaryContract,
} from 'models'
import { GiftCardSaleLookupContract, SaleRefundProcessContract } from 'models'
import {
    SaleDetailsContract,
    SaleRefundDetailContract,
    SaleRefundModelSlim,
} from 'models'
import { TSaleState } from 'pages/DashboardPage/Dashboard'
import { searchOrderRequest } from 'store/actions/orderLookup.action'

const LOCATION_SALES = '/location/sales'

export interface SearchOrderSaleRequest {
    startDate?: Dayjs
    endDate?: Dayjs
    paymentTypeID?: number
    employeeIDs?: string[]
    saleType: SaleType
    employeeID?: string
    tableGroupID?: string
    tableID?: string
    searchText?: string
    orderFulfillmentTypeIDs?: number[]
}
export interface SearchGiftCardSaleLookupRequest extends searchOrderRequest {}
const salesService = {
    getSales: (filter?: SearchOrderSaleRequest) =>
        httpRequest.get<SaleLookupContract[]>(LOCATION_SALES, {
            params: filter,
        }),
    getGiftCardSales: (filter?: SearchGiftCardSaleLookupRequest) =>
        httpRequest.get<GiftCardSaleLookupContract[]>(
            `${LOCATION_SALES}/gift-cards`,
            {
                params: filter,
            },
        ),
    getGiftCardSale: (id: string) =>
        httpRequest.get<GiftCardSaleDetailContract>(
            `${LOCATION_SALES}/gift-cards/${id}`,
        ),
    getSaleByID: (saleID: string) =>
        httpRequest.get<SaleDetailsContract>(`${LOCATION_SALES}/${saleID}`),
    getRefunds: (filter?: SearchOrderSaleRequest) =>
        httpRequest.get<SaleRefundModelSlim[]>(`${LOCATION_SALES}/refunds`, {
            params: filter,
        }),
    getRefundByID: (refundID: string) =>
        httpRequest.get<SaleRefundDetailContract>(
            `${LOCATION_SALES}/refunds/${refundID}`,
        ),
    getSaleRefundsBySaleID: (saleID: string) =>
        httpRequest.get<SaleRefundDetailLookupContract[]>(
            `${LOCATION_SALES}/refunds/sale/${saleID}`,
        ),
    processRefund: (
        receiptID: string,
        payload: SaleRefundProcessContract,
        isContinueProcess: boolean = false,
    ) => {
        return httpRequest.post<CompletableContract>(
            `${LOCATION_SALES}/${receiptID}/refund`,
            payload,
            { params: { isContinueProcess } },
        )
    },
    processDeviceRefund: (
        receiptID: string,
        payload: SaleRefundProcessContract,
    ) => {
        return httpRequest.post<string[]>(
            `${LOCATION_SALES}/${receiptID}/device-refund`,
            payload,
        )
    },
    getSalesSummary: (
        date?: DateRange<Dayjs>,
        locationIds?: string[],
        saleState?: TSaleState,
    ) =>
        httpRequest.get<SummaryContract>('/company/sales-summary', {
            params: {
                startDate: date?.[0]?.toISOString(),
                endDate: date?.[1]?.toISOString(),
                locationIds,
                saleState,
            },
        }),
    checkDeviceRefundProcess: (receiptID: string) => {
        return httpRequest.get<PaymentResultContract[]>(
            `${LOCATION_SALES}/${receiptID}/check-device-refund-process-status`,
        )
    },
}

export default salesService
